import React from "react";

interface ErrorMessageProps {
  message?: string | null;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message = "Error Occured",
}) => {
  return (
    <div className="text-red-500 text-center py-4">
      <p>{message}</p>
    </div>
  );
};

export default ErrorMessage;
